import React, { useState } from 'react';
import { PlanChooser, WikiWrapper } from 'apps/components';
import { routerStore } from 'core/routing';
import { Icon } from 'components';
import { getInviteLink, redirectToInviteLink } from 'apps/utils';
import { clientStore } from 'apps/client/app';

export const ChoosePlan = () => {
  const [planMode, setPlanMode] = useState('company');

  const selectedIndividual = planMode === 'individual';

  const isOnboardingChoosePlan = routerStore.route.name?.startsWith?.(
    'onboarding.choosePlan',
  );

  return (
    <WikiWrapper hiddenLogo={clientStore.signedInProfile}>
      <PlanChooser
        className='h-full'
        hideSwitcher
        shouldShowOneRow
        onClickSwitch={setPlanMode}
        isOnboardingChoosePlan={isOnboardingChoosePlan}
        onClickIndividualFree={() => {
          // if (
          //   routerStore.route.name?.startsWith?.('onboarding.choosePlan') &&
          //   getInviteLink()
          // ) {
          //   redirectToInviteLink();
          //   return;
          // }
          // routerStore.navigate('home');
        }}
        // onClickIndividualForKind={() => {
        //   routerStore.navigate('onboarding.subscription.individual', {
        //     productType: 'pro',
        //   });
        // }}
        onClickCompanyForTeam={() => {
          routerStore.navigate('onboarding.subscription.company', {
            productType: 'pro',
          });
        }}
        onClickCompanyForBusiness={() => {
          routerStore.navigate('onboarding.subscription.company', {
            productType: 'business',
          });
        }}
        selectedIndividual={selectedIndividual}
      />
    </WikiWrapper>
  );
};
